/**
 * Jazyk
 */
export enum Language {
  /**
   * Česky
   */
  CZECH = 'CZECH',

  /**
   * English
   */
  ENGLISH = 'ENGLISH',

  /**
   * Deutsch
   */
  GERMAN = 'GERMAN',

  /**
   * Slovensky
   */
  SLOVAK = 'SLOVAK',

  /**
   * Ukrajinsky
   */
  UKRAINIAN = 'UKRAINIAN',
}
